import { SecondaryButton } from 'src/components/design-system/form/buttons/SecondaryButton';
import { PrimaryButton } from 'src/components/design-system/form/buttons/PrimaryButton';
import { Formik, FormikValues } from 'formik';
import classNames from 'classnames';

export type FormButtonsProps<T extends FormikValues = any> = {
    className?: classNames.Argument;
    formik?: Formik<T>;

    onCancel?: () => void;
    cancelLabel?: string;
    cancelClassName?: classNames.Argument;
    showCancel?: boolean;
    isCancelLoading?: boolean;

    onSubmit?: () => void;
    submitLabel?: string;
    submitClassName?: classNames.Argument;
    showSubmit?: boolean;
    isSubmitLoading?: boolean;
};

export const FormButtons = (props: FormButtonsProps) => {
    const {
        submitLabel = 'Принять',
        cancelLabel = 'Отменить',
        showSubmit = true,
        showCancel = true,
    } = props;

    return (
        <div className={classNames('form-buttons', props.className)}>
            {showCancel && (
                <SecondaryButton
                    className={classNames(props.cancelClassName)}
                    loading={props.isCancelLoading}
                    label={cancelLabel}
                    onClick={props.onCancel}
                />
            )}

            {showSubmit && (
                <PrimaryButton
                    className={classNames(props.submitClassName)}
                    loading={props.isSubmitLoading}
                    label={submitLabel}
                    formik={props.formik}
                    onClick={props.onSubmit}
                    submit={true}
                />
            )}
        </div>
    );
};
